function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import componentPropType from '@signal/prop-types/component';
import renderIf from '@signal/utils/renderIf';
import { menuListItemsPropType } from './propTypes';
import { ListWrapper, MenuItemText, SubMenuItemText } from './styles';
export var MenuList = function MenuList(props) {
  var defaultDividers = props.defaultDividers,
      listItems = props.listItems,
      onMenuItemClick = props.onMenuItemClick,
      MenuItemTextComponent = props.MenuItemTextComponent,
      SubMenuItemTextComponent = props.SubMenuItemTextComponent,
      rest = _objectWithoutProperties(props, ["defaultDividers", "listItems", "onMenuItemClick", "MenuItemTextComponent", "SubMenuItemTextComponent"]);

  var handleMenuItemClick = function handleMenuItemClick(link) {
    return function () {
      return onMenuItemClick(link);
    };
  };

  var renderSubMenuItems = function renderSubMenuItems(items) {
    return _map(items, function (item, i) {
      return renderIf(item, function () {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: i,
          onClick: handleMenuItemClick(item.link)
        }, /*#__PURE__*/React.createElement(ListItemText, {
          inset: true
        }, /*#__PURE__*/React.createElement(SubMenuItemTextComponent, null, item.text || item.name)));
      });
    });
  };

  return /*#__PURE__*/React.createElement(ListWrapper, null, /*#__PURE__*/React.createElement(List, rest, _map(listItems, function (_ref, i) {
    var title = _ref.title,
        name = _ref.name,
        link = _ref.link,
        IconComponent = _ref.icon,
        TextComponent = _ref.textComponent,
        subMenuItems = _ref.subMenuItems,
        divider = _ref.divider,
        _ref$attributes = _ref.attributes,
        attributes = _ref$attributes === void 0 ? {} : _ref$attributes;
    var ListComponent = link ? MenuItem : ListItem;
    var MenuItemTextComponentUse = TextComponent || MenuItemTextComponent;
    return /*#__PURE__*/React.createElement("div", {
      key: i
    }, /*#__PURE__*/React.createElement(ListComponent, Object.assign({}, attributes, {
      onClick: link ? handleMenuItemClick(link) : null
    }), /*#__PURE__*/React.createElement(ListItemIcon, null, renderIf(IconComponent, function () {
      return /*#__PURE__*/React.createElement(IconComponent, null);
    })), /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(MenuItemTextComponentUse, null, title || name))), renderIf(subMenuItems, function () {
      return renderSubMenuItems(subMenuItems);
    }), renderIf(divider || defaultDividers, function () {
      return /*#__PURE__*/React.createElement(Divider, null);
    }));
  })));
};
MenuList.propTypes = {
  listItems: menuListItemsPropType.isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  MenuItemTextComponent: componentPropType,
  SubMenuItemTextComponent: componentPropType
};
MenuList.defaultProps = {
  MenuItemTextComponent: MenuItemText,
  SubMenuItemTextComponent: SubMenuItemText
};
export default MenuList;